export default "images/jilin.png";